import { gql } from '@apollo/client';

export const SendChatMessageMutation = gql`
    mutation SendChatMessage($message: String!, $chatId: ID!) {
        sendChatMessage(message: $message, chatId: $chatId) {
            id
            message
            sender {
                id
                fullName
            }
            createdAt
            updatedAt
        }
    }
`;
